import logos from '/images/unauthenticated-page-logo.png';

const WelcomeBanner = () => {
  return (
    <div className="h-full flex-nowrap flex-col flex items-center lg:items-center justify-center p-0 xl:p-4">
      <img src={logos} width={200} height={100} alt="Logo" />
      <h1 className="text-white text-2xl sm:text-4xl lg:text-3xl 2xl:text-6xl  font-bold mt-[25px] mb-[15px]">
        Welcome to Practivated
      </h1>
      <p className="text-white max-w-xs text-lg">
        Strengthen Your Conversations. Maximize Your Impact.
      </p>
    </div>
  );
};

export default WelcomeBanner;
